import { useLocation } from 'react-router-dom'
import { StringUtils } from '../../utils/StringUtils';

export const useEntityFromRoute = () => {
  const location = useLocation();
  const match = location.pathname.match(/^\/[^/]+\/([^/]+)/);
  return match ? StringUtils.toCodeConvention(match[1]) : null;
}
